import { IProppantType } from '../../interfaces/iproppant-type';
import { Item } from '../item';

export class ProppantTypeBase {
  ProppantTypeId: number;
  Description: string | null;
  ItemId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Item?: Item;

  constructor(item?: IProppantType) {
    if (item) {

      this.ProppantTypeId = item.ProppantTypeId;
      this.Description = item.Description;
      this.ItemId = item.ItemId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Item = new Item(item.Item);
    }
  }
}